// extracted by mini-css-extract-plugin
export default {"controlWifiCont":"control-bluetooth_controlWifiCont__W0Gtk","header":"control-bluetooth_header__DL2bq"};